// extracted by mini-css-extract-plugin
module.exports = {"datepicker":"Users_datepicker__3CdOs","modal":"Users_modal__1hAxC","paper":"Users_paper__2aEg5","root":"Users_root__Wi1gD","table":"Users_table__S6fQ6"};